module.exports = __webpack_public_path__ + "img/Bingo2_Info_Game_8.479cd821.png";